var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a-drawer",
    {
      attrs: {
        title: _vm.title,
        width: 800,
        placement: "right",
        closable: false,
        visible: _vm.visible,
      },
      on: { close: _vm.close },
    },
    [
      _c(
        "a-spin",
        { attrs: { spinning: _vm.confirmLoading } },
        [
          _c(
            "a-form-model",
            {
              ref: "form",
              attrs: { model: _vm.model, rules: _vm.validatorRules },
            },
            [
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    prop: "tenantId",
                    label: "租户ID",
                  },
                },
                [
                  _c("a-input-number", {
                    model: {
                      value: _vm.model.tenantId,
                      callback: function ($$v) {
                        _vm.$set(_vm.model, "tenantId", $$v)
                      },
                      expression: "model.tenantId",
                    },
                  }),
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    prop: "serialNo",
                    label: "设备编号",
                  },
                },
                [
                  _c("a-input", {
                    attrs: { placeholder: "请输入设备编号" },
                    model: {
                      value: _vm.model.serialNo,
                      callback: function ($$v) {
                        _vm.$set(_vm.model, "serialNo", $$v)
                      },
                      expression: "model.serialNo",
                    },
                  }),
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    prop: "cameraName",
                    label: "摄像头名称",
                  },
                },
                [
                  _c("a-input", {
                    attrs: { placeholder: "请输入摄像头名称" },
                    model: {
                      value: _vm.model.cameraName,
                      callback: function ($$v) {
                        _vm.$set(_vm.model, "cameraName", $$v)
                      },
                      expression: "model.cameraName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    prop: "actionArea",
                    label: "安装位置",
                  },
                },
                [
                  _c("a-input", {
                    attrs: { placeholder: "请输入安装位置" },
                    model: {
                      value: _vm.model.actionArea,
                      callback: function ($$v) {
                        _vm.$set(_vm.model, "actionArea", $$v)
                      },
                      expression: "model.actionArea",
                    },
                  }),
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    prop: "delFlag",
                    label: "删除标志位",
                  },
                },
                [
                  _c("a-input-number", {
                    model: {
                      value: _vm.model.delFlag,
                      callback: function ($$v) {
                        _vm.$set(_vm.model, "delFlag", $$v)
                      },
                      expression: "model.delFlag",
                    },
                  }),
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    prop: "regId",
                    label: "7500注册返回ID",
                  },
                },
                [
                  _c("a-input-number", {
                    model: {
                      value: _vm.model.regId,
                      callback: function ($$v) {
                        _vm.$set(_vm.model, "regId", $$v)
                      },
                      expression: "model.regId",
                    },
                  }),
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    prop: "subscriptionUrl",
                    label: "订阅地址",
                  },
                },
                [
                  _c("a-input", {
                    attrs: { placeholder: "请输入订阅地址" },
                    model: {
                      value: _vm.model.subscriptionUrl,
                      callback: function ($$v) {
                        _vm.$set(_vm.model, "subscriptionUrl", $$v)
                      },
                      expression: "model.subscriptionUrl",
                    },
                  }),
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    prop: "subscriptionId",
                    label: "订阅号",
                  },
                },
                [
                  _c("a-input-number", {
                    model: {
                      value: _vm.model.subscriptionId,
                      callback: function ($$v) {
                        _vm.$set(_vm.model, "subscriptionId", $$v)
                      },
                      expression: "model.subscriptionId",
                    },
                  }),
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    prop: "surveillanceId",
                    label: "布控号",
                  },
                },
                [
                  _c("a-input-number", {
                    model: {
                      value: _vm.model.surveillanceId,
                      callback: function ($$v) {
                        _vm.$set(_vm.model, "surveillanceId", $$v)
                      },
                      expression: "model.surveillanceId",
                    },
                  }),
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    prop: "threshold",
                    label: "布控相似度阀值",
                  },
                },
                [
                  _c("a-input-number", {
                    model: {
                      value: _vm.model.threshold,
                      callback: function ($$v) {
                        _vm.$set(_vm.model, "threshold", $$v)
                      },
                      expression: "model.threshold",
                    },
                  }),
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    prop: "ip",
                    label: "ip",
                  },
                },
                [
                  _c("a-input", {
                    attrs: { placeholder: "请输入ip" },
                    model: {
                      value: _vm.model.ip,
                      callback: function ($$v) {
                        _vm.$set(_vm.model, "ip", $$v)
                      },
                      expression: "model.ip",
                    },
                  }),
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    prop: "username",
                    label: "username",
                  },
                },
                [
                  _c("a-input", {
                    attrs: { placeholder: "请输入username" },
                    model: {
                      value: _vm.model.username,
                      callback: function ($$v) {
                        _vm.$set(_vm.model, "username", $$v)
                      },
                      expression: "model.username",
                    },
                  }),
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    prop: "password",
                    label: "password",
                  },
                },
                [
                  _c("a-input", {
                    attrs: { placeholder: "请输入password" },
                    model: {
                      value: _vm.model.password,
                      callback: function ($$v) {
                        _vm.$set(_vm.model, "password", $$v)
                      },
                      expression: "model.password",
                    },
                  }),
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    prop: "port",
                    label: "port",
                  },
                },
                [
                  _c("a-input-number", {
                    model: {
                      value: _vm.model.port,
                      callback: function ($$v) {
                        _vm.$set(_vm.model, "port", $$v)
                      },
                      expression: "model.port",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "drawer-bootom-button" },
        [
          _c(
            "a-button",
            { attrs: { type: "primary" }, on: { click: _vm.handleOk } },
            [_vm._v("确定")]
          ),
          _c(
            "a-button",
            { attrs: { type: "primary" }, on: { click: _vm.handleCancel } },
            [_vm._v("取消")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }